<template>

  <!-- FILE UPLOAD BUTTON -->
  <form class="form" enctype="multipart/form-data" novalidate>
    <label class="myLabel c-hand">
      <input class="form-input" type="file" @change="upload" :disabled="saving">
      <span :class="{loading: saving}"><i class="fa fa-cloud-upload" aria-hidden="true"></i> Upload</span>
    </label>
    <label v-if="error" class="label label-error">{{error}}</label>
  </form>
  <!-- END FILE UPLOAD BUTTON -->

</template>

<script>
import axios from 'axios'
export default {
  name: 'upload',
  props: ['matter', 'doctype'],
  data () {
    return {
      error: '',
      saving: false
    }
  },
  methods: {
    upload (e) {
      if (!e.target.files.length) return
      let file = e.target.files[0]

      this.saving = true
      this.error = ''
      let form = new FormData()
      form.append('file', file, file.name)
      form.append('name', file.name)
      form.append('matter_id', this.matter._id)
      form.append('docref', this.doctype.ref)

      axios.post('/api/drive/upload', form)
      .then(res => {
        if (res.status === 200) {
          const newFile = {
            id: res.data.id,
            name: res.data.name,
            docref: this.doctype.ref,
            accepted: false
          }
          this.saving = false
          this.$emit('new', newFile)
        }
      })
      .catch(e => {
        this.saving = false
        this.error = e.response.data
      })
    }
  }
}
</script>

<style scoped>
label.myLabel input[type="file"] {
    position: fixed;
    top: -1000px;
}

/***** Example custom styling *****/
.myLabel {
    border-radius: 2px;
    padding: 0.2em 0.6em;
    margin: 1em 0 0 0;
    background: #136efb;
    display: inline-block;
}
.myLabel:hover {
    background: #0358d8!important
}
.myLabel:active {
    background: #6ebef7;
}
.myLabel :invalid + span {
    color: #A44;
}
.myLabel :valid + span {
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// upload.vue?75023762